import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as UserService from '_services/user-service';

const initialState = {
    adminTable: null,
    status: 'idle',
    blockStatus: 'idle',
    approvedStatus: 'idle',
    resetPasswordStatus: 'idle',
    approvedAccountsTable: [],
    unverifiedAccountsTable: [],
    totalApprovesAccounts: 0,
    totalUnVerifiedAccounts: 0,
    error: null,
    currentPage: 1,
    rowsPerPage: 10,
};

// get approvedAccount
export const getApprovedAccounts = createAsyncThunk('adminTable/approvedAccounts', async (params) => {
    return UserService.getPortalAccounts(params);
});

// get accounts which need approve/block
export const getUnverifiedAccounts = createAsyncThunk('adminTable/getUnverifiedAccounts', async (params) => {
    return UserService.getPortalAccounts(params);
});

export const blockAccount = createAsyncThunk('adminTable/blockAccount', async (id) => {
    return UserService.blockAccount(id);
});

export const resetPassword = createAsyncThunk('adminTable/resetPassword', async (email) => {
    return UserService.resetPasswordService(email);
});

const adminTableSlice = createSlice({
    name: 'adminTable',
    initialState,
    reducers: {
        reset: (state) => initialState,
        resetActionsFlags: state => {
            state.blockStatus = "idle";
            state.resetPasswordStatus = "idle";
            state.approvedStatus = "idle"
        },
        setCurrentPage(state, action) {
            state.currentPage = action.payload;
        },
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
    },
    extraReducers: {
        [getUnverifiedAccounts.pending]: (state, action) => {
            return {
                ...state,
                status: 'loading',
            }
        },
        [getUnverifiedAccounts.fulfilled]: (state, action) => {
            return {
                ...state,
                status: 'succeeded',
                unverifiedAccountsTable: action.payload?.users,
                totalUnVerifiedAccounts: action.payload?.total

            }
        },
        [getUnverifiedAccounts.rejected]: (state, action) => {
            return {
                ...state,
                status: 'failed',
                error: action.error.message,
            }
        },
        [getApprovedAccounts.pending]: (state, action) => {
            return {
                ...state,
                status: 'loading',
            }
        },
        [getApprovedAccounts.fulfilled]: (state, action) => {
            return {
                ...state,
                status: 'succeeded',
                approvedAccountsTable: action.payload?.users,
                totalApprovesAccounts: action.payload?.total
            }
        },
        [getApprovedAccounts.rejected]: (state, action) => {
            return {
                ...state,
                status: 'failed',
                error: action.error.message,
            }
        },
        [blockAccount.pending]: (state, action) => {
            return {
                ...state,
                blockStatus: 'loading',
            }
        },
        [blockAccount.fulfilled]: (state, action) => {
            return {
                ...state,
                blockStatus: 'succeeded',
            }
        },
        [blockAccount.rejected]: (state, action) => {
            return {
                ...state,
                blockStatus: 'failed',
                error: action.error.message,
            }
        },
        [resetPassword.pending]: (state, action) => {
            return {
                ...state,
                resetPasswordStatus: 'loading',
            }
        },
        [resetPassword.fulfilled]: (state, action) => {
            return {
                ...state,
                resetPasswordStatus: 'succeeded',
            }
        },
        [resetPassword.rejected]: (state, action) => {
            return {
                ...state,
                resetPasswordStatus: 'failed',
                error: action.error.message,
            }
        }
    }
});




export const { reset, resetActionsFlags, setRowsPerPage, setCurrentPage } = adminTableSlice.actions;
export const selectGettingAccountsStatus = state => state.adminTable.status;
export const selectBlockStatus = state => state.adminTable.blockStatus;
export const selectApprovedAccounts = state => state.adminTable.approvedAccountsTable;
export const selectUnverifiedAccounts = state => state.adminTable.unverifiedAccountsTable;
export const selectTotalApprovedAccounts = state => state.adminTable.totalApprovesAccounts;
export const selectTotalUnverifiedAccounts = state => state.adminTable.totalUnVerifiedAccounts;
export const selectResetPasswordStatus = state => state.adminTable.resetPasswordStatus;

export const selectCurrentPage = state => state.adminTable.currentPage;
export const selectRowsPerPage = state => state.adminTable.rowsPerPage;
export default adminTableSlice.reducer;
